// Detects whether the current session is running inside the Google Play Store
// Trusted Web Activity (TWA) wrapper — i.e. the CrewOS Android app launched
// from the Play Store home-screen icon.
//
// Detection requires TWO signals, both true (conjunction):
//   (1) display-mode: standalone — launch surface is full-screen (not a Chrome tab)
//   (2) document.referrer starts with "android-app://" — Chrome injects this
//       when the session originated from a TWA launcher intent
//
// Why both: (1) alone matches desktop "Install as app" PWAs and iOS home-screen
// PWAs, which are NOT Play Store TWAs and should retain full in-app billing UX
// (no Google policy applies there). (2) alone is not sufficient either — any
// page can be linked from an Android app, so conjunction = high-confidence.
//
// Used to gate in-app payment surfaces per the Play Store "companion app"
// pattern. See docs/plans/2026-04-19-play-store-twa-launch.md.
import { useEffect, useState } from 'react'

export function useIsTWA() {
  const [isTWA, setIsTWA] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') return
    const standalone = window.matchMedia?.('(display-mode: standalone)').matches ?? false
    const androidApp = document.referrer.startsWith('android-app://')
    setIsTWA(standalone && androidApp)
  }, [])
  return isTWA
}
